import {
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Button,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";

interface PaginationDropdownProps {
    totalPages: number;
    currentPage: number;
    onPageChange: (page: number) => void;
}

export const PaginationDropdown = ({
    totalPages,
    currentPage,
    onPageChange,
}: PaginationDropdownProps) => {
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

    return (
        <Menu>
            <MenuButton
                as={Button}
                size="sm"
                rightIcon={<ChevronDownIcon />}
                width="80px"
            >
                {currentPage}
            </MenuButton>
            <MenuList maxH="160px" overflowY="auto" minW="80px" maxW="80px">
                {pages.map((page) => (
                    <MenuItem key={page} onClick={() => onPageChange(page)}>
                        {page}
                    </MenuItem>
                ))}
            </MenuList>
        </Menu>
    );
};
